module.exports = __webpack_public_path__ + "static/media/new-york-21.72f7b9c7.jpg";